/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Row, Col, Input, Button, message, Spin, Table, Modal } from "antd";
import zone_location_circle from "../../../assests/images/master/zone-location-circle.svg";
import city_icon from "../../../assests/images/master/city.svg";
import scooter from "../../../assests/images/master/scooter.svg";
import with_in_state from "../../../assests/images/master/with_in_state.svg";
import rest_of_india from "../../../assests/images/master/restofindia-icon.svg";
import search_icon from "../../../assests/images/search-icon.svg";
import API from "../../../api";
import urls from "../../../api/urls";
import { capitaliseWithHyphen, showErrorMessage } from "../../../utils";
import { useNavigate, useParams } from "react-router-dom";

const { GET_CLIENT_APPROVAL_PINCODE_MAP } = urls;

export const viewPincodeMap = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [dataSourceParent, setDataSourceParent] = useState([]);
  const [modalData, setModalData] = useState([]);
  const [pincodeData, setPincodeData] = useState(null);
  const [pincodeModalVisible, setPincodeModalVisible] = useState(false);
  const [inputSearchValue, setInputSearchVal] = useState("");

  const columns = [
    {
      title: (
        <div className="d-flex align-center">
          <img src={scooter} />
          <span>Local</span>
        </div>
      ),
      dataIndex: "local",
      width: 130,
      render: (text, _record, index) => (
        <>
          {text ? (
            <div className="d-flex">
              <span style={{ color: "#000" }}>
                {capitaliseWithHyphen(text)}
              </span>
              <Button
                className="pin-code-count"
                onClick={() => openPincodeModal(_record.localValue)}
              >
                {_record.localValue.length}
              </Button>
            </div>
          ) : (
            "------"
          )}
        </>
      ),
    },
    {
      title: (
        <div className="d-flex align-center">
          <img src={with_in_state} />
          <span>Within State</span>
        </div>
      ),
      dataIndex: "withInState",
      width: 130,
      render: (text, _record) => (
        <>
          {text ? (
            <div className="d-flex">
              <span style={{ color: "#000" }}>
                {capitaliseWithHyphen(text)}
              </span>
              <Button
                className="pin-code-count"
                onClick={() => openPincodeModal(_record.withInStateValue)}
              >
                {_record.withInStateValue.length}
              </Button>
            </div>
          ) : (
            "------"
          )}
        </>
      ),
    },
    {
      title: (
        <div className="d-flex align-center">
          <img src={zone_location_circle} />
          <span>My Zone 1</span>
        </div>
      ),
      dataIndex: "myZoneOne",
      width: 130,
      render: (text, _record, index) => (
        <>
          {text ? (
            <div className="d-flex">
              <span style={{ color: "#2E77D0" }}>
                {capitaliseWithHyphen(text)}
              </span>
              <Button
                className="pin-code-count"
                onClick={() => openPincodeModal(_record.myZoneOneValue)}
              >
                {_record.myZoneOneValue.length}
              </Button>
            </div>
          ) : (
            "------"
          )}
        </>
      ),
    },
    {
      title: (
        <div className="d-flex align-center">
          <img src={zone_location_circle} />
          <span>My Zone 2</span>
        </div>
      ),
      dataIndex: "myZoneTwo",
      width: 130,
      render: (text, _record, index) => (
        <>
          {text ? (
            <div className="d-flex">
              <span style={{ color: "#2E77D0" }}>
                {capitaliseWithHyphen(text)}
              </span>
              <Button
                className="pin-code-count"
                onClick={() => openPincodeModal(_record.myZoneTwoValue)}
              >
                {_record.myZoneTwoValue.length}
              </Button>
            </div>
          ) : (
            "------"
          )}
        </>
      ),
    },
    {
      title: (
        <div className="d-flex align-center">
          <img src={zone_location_circle} />
          <span>My Zone 3</span>
        </div>
      ),
      dataIndex: "myZoneThree",
      width: 130,
      render: (text, _record, index) => (
        <>
          {text ? (
            <div className="d-flex">
              <span style={{ color: "#2E77D0" }}>
                {capitaliseWithHyphen(text)}
              </span>
              <Button
                className="pin-code-count"
                onClick={() => openPincodeModal(_record.myZoneThreeValue)}
              >
                {_record.myZoneThreeValue.length}
              </Button>
            </div>
          ) : (
            "------"
          )}
        </>
      ),
    },
    {
      title: (
        <div className="d-flex align-center">
          <img src={zone_location_circle} />
          <span>My Zone 4</span>
        </div>
      ),
      dataIndex: "myZoneFour",
      width: 130,
      render: (text, _record, index) => (
        <>
          {text ? (
            <div className="d-flex">
              <span style={{ color: "#2E77D0" }}>
                {capitaliseWithHyphen(text)}
              </span>
              <Button
                className="pin-code-count"
                onClick={() => openPincodeModal(_record.myZoneFourValue)}
              >
                {_record.myZoneFourValue.length}
              </Button>
            </div>
          ) : (
            "------"
          )}
        </>
      ),
    },
    {
      title: (
        <div className="d-flex align-center">
          <img src={city_icon} />
          <span>Metro</span>
        </div>
      ),
      dataIndex: "metro",
      render: (text, _record, index) => (
        <>
          {text ? (
            <div className="d-flex">
              <span style={{ color: "#2E77D0" }}>
                {capitaliseWithHyphen(text)}
              </span>
              <Button
                className="pin-code-count"
                onClick={() => openPincodeModal(_record.metroValue)}
              >
                {_record.metroValue.length}
              </Button>
            </div>
          ) : (
            "------"
          )}
        </>
      ),
      width: 130,
    },
    {
      title: (
        <div className="d-flex align-center">
          <img src={zone_location_circle} />
          <span>Special locations</span>
        </div>
      ),
      dataIndex: "specialPlaces",
      width: 130,
      render: (text, _record, index) => (
        <>
          {text ? (
            <div className="d-flex">
              <span style={{ color: "#2E77D0" }}>
                {capitaliseWithHyphen(text)}
              </span>
              <Button
                className="pin-code-count"
                onClick={() => openPincodeModal(_record.specialPlacesValue)}
              >
                {_record.specialPlacesValue.length}
              </Button>
            </div>
          ) : (
            "------"
          )}
        </>
      ),
    },
    {
      title: (
        <div className="d-flex align-center">
          <img src={rest_of_india} />
          <span>Rest of India</span>
        </div>
      ),
      dataIndex: "restOfIndia",
      width: 130,
      render: (text, _record, index) => (
        <>
          {text ? (
            <div className="d-flex">
              <span style={{ color: "#2E77D0" }}>
                {capitaliseWithHyphen(text)}
              </span>
              <Button
                className="pin-code-count"
                onClick={() => openPincodeModal(_record.restOfIndiaValue)}
              >
                {_record.restOfIndiaValue.length}
              </Button>
            </div>
          ) : (
            "------"
          )}
        </>
      ),
    },
  ];

  const openPincodeModal = (value) => {
    setModalData(value);
    setPincodeModalVisible(true);
  };

  useEffect(() => {
    getPincodeMappingDetails();
  }, []);

  const getPincodeMappingDetails = async () => {
    let response = await API.Api(
      GET_CLIENT_APPROVAL_PINCODE_MAP + `${params?.id}`
    ).getWithUserNPremiseHeader();
    if (response?.status) {
      getTableData(response?.response?.data);
      setPincodeData(response?.response?.data?.pincode);
    } else {
      showErrorMessage(response?.response?.data?.message || "Network error");
    }
  };

  const getTableData = (result) => {
    let {
      localMap,
      metroMap,
      restOfIndiaMap,
      withInStateMap,
      specialPlacesMap,
      myZoneOneMap,
      myZoneTwoMap,
      myZoneThreeMap,
      myZoneFourMap,
    } = result;
    let local = Object.keys(localMap || []);
    let localValue = Object.values(localMap || []);
    let metro = Object.keys(metroMap || []);
    let metroValue = Object.values(metroMap || []);
    let restOfIndia = Object.keys(restOfIndiaMap || []);
    let restOfIndiaValue = Object.values(restOfIndiaMap || []);
    let withInState = Object.keys(withInStateMap || []);
    let withInStateValue = Object.values(withInStateMap || []);
    let specialPlaces = Object.keys(specialPlacesMap || []);
    let specialPlacesValue = Object.values(specialPlacesMap || []);
    let myZoneOne = Object.keys(myZoneOneMap || []);
    let myZoneOneValue = Object.values(myZoneOneMap || []);
    let myZoneTwo = Object.keys(myZoneTwoMap || []);
    let myZoneTwoValue = Object.values(myZoneTwoMap || []);
    let myZoneThree = Object.keys(myZoneThreeMap || []);
    let myZoneThreeValue = Object.values(myZoneThreeMap || []);
    let myZoneFour = Object.keys(myZoneFourMap || []);
    let myZoneFourValue = Object.values(myZoneFourMap || []);

    let lengthTest = [
      metro?.length,
      restOfIndia?.length,
      withInState?.length,
      specialPlaces?.length,
      myZoneOne?.length,
      myZoneTwo?.length,
      myZoneThree?.length,
      myZoneFour?.length,
    ].sort((a, b) => {
      return a - b;
    });
    let dataSourceTemp = [];
    for (let i = 0; i < lengthTest[lengthTest.length - 1]; i++) {
      dataSourceTemp.push({
        local: local[i] !== undefined ? local[i] : null,
        localValue: localValue[i] !== undefined ? localValue[i] : null,
        metro: metro[i] !== undefined ? metro[i] : null,
        metroValue: metroValue[i] !== undefined ? metroValue[i] : null,
        restOfIndia: restOfIndia[i] !== undefined ? restOfIndia[i] : null,
        restOfIndiaValue:
          restOfIndiaValue[i] !== undefined ? restOfIndiaValue[i] : null,
        withInState: withInState[i] !== undefined ? withInState[i] : null,
        withInStateValue:
          withInStateValue[i] !== undefined ? withInStateValue[i] : null,
        specialPlaces: specialPlaces[i] !== undefined ? specialPlaces[i] : null,
        specialPlacesValue:
          specialPlacesValue[i] !== undefined ? specialPlacesValue[i] : null,
        myZoneOne: myZoneOne[i] !== undefined ? myZoneOne[i] : null,
        myZoneOneValue:
          myZoneOneValue[i] !== undefined ? myZoneOneValue[i] : null,
        myZoneTwo: myZoneTwo[i] !== undefined ? myZoneTwo[i] : null,
        myZoneTwoValue:
          myZoneTwoValue[i] !== undefined ? myZoneTwoValue[i] : null,
        myZoneThree: myZoneThree[i] !== undefined ? myZoneThree[i] : null,
        myZoneFour: myZoneFour[i] !== undefined ? myZoneFour[i] : null,
        myZoneThreeValue:
          myZoneThreeValue[i] !== undefined ? myZoneThreeValue[i] : null,
        myZoneFourValue:
          myZoneFourValue[i] !== undefined ? myZoneFourValue[i] : null,
      });
    }
    setDataSourceParent(dataSourceTemp);
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  return (
    <div className="p-2">
      <Row>
        <Col span={24} className="mb-1">
          <div className="space-between" style={{ alignItems: "center" }}>
            <div className="">
              <span className="master-title">Pincode Mapping:</span>
              <span style={{ fontSize: "16px", fontWeight: "500" }}>
                {" " + pincodeData}
              </span>
              {/* <span>&nbsp;{userId?.premises?.city + " / "}</span>
              <span>
                {userId?.premises?.state ? userId?.premises?.state + " / " : ""}
              </span>
              <span>{userId?.premises?.zone}</span> */}
            </div>

            <div className="text-right p-1">
              <Input
                placeholder="Search by keyword"
                bordered
                // onChange={onSearch}
                style={{ borderRadius: "5px", height: "40px", width: "400px" }}
                suffix={<img src={search_icon} />}
              />
            </div>
          </div>
          <hr className="divider" />
        </Col>
        <Table
          columns={columns}
          dataSource={dataSourceParent}
          pagination={{
            itemRender: itemRender,
            pageSizeOptions: [5, 10, 20, 50, 100],
          }}
          scroll={{
            x: 1700,
          }}
        />
      </Row>
      <hr className="divider" />
      <div className="flex-end p-1">
        <Button
          className="cancel-btn ml-1 "
          onClick={() => navigate("/approve-dp/" + params?.id)}
        >
          BACK
        </Button>
        <Button
          htmlType="submit"
          className="save-btn w-15  ml-1"
          onClick={() => navigate("/view-rate-card/" + params?.id)}
        >
          VIEW RATE CARD
        </Button>
      </div>

      <Modal
        className="pincode-mapping-modal"
        title={"Pincodes"}
        open={pincodeModalVisible}
        onCancel={() => setPincodeModalVisible(false)}
        footer={null}
        maskClosable={false}
        destroyOnClose
      >
        <Row className="pincode-mapping-modal-container" gutter={37}>
          {modalData?.map((data, idx) => (
            <Col key={idx} className="pincode-data">
              {data}
            </Col>
          ))}
        </Row>
      </Modal>
    </div>
  );
};

export default viewPincodeMap;
